import { useContext, useMemo } from 'react';
import { useRouter } from 'next/router';
import { EVENT_TRACKING_CATEGORIES } from '../constants/AnalyticsConstants';
import { AppContext } from '../contexts/AppContextProvider';

export default () => {
  const router = useRouter();
  const pathname = `${router.basePath}${router.pathname}`;
  const { paths } = useContext(AppContext);

  return useMemo(() => {
    if (pathname.includes(paths.leadsPage)) {
      return EVENT_TRACKING_CATEGORIES.MULTI_FAMILY_LEAD_MANAGEMENT;
    } else if (pathname.includes(paths.inboxPage)) {
      return EVENT_TRACKING_CATEGORIES.INBOX_PAGE;
    } else if (pathname.includes(paths.leadManagementPage)) {
      return EVENT_TRACKING_CATEGORIES.LEAD_MANAGEMENT_PAGE;
    } else {
      return '';
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- preserving existing behavior; not re-verified
  }, [pathname]);
};
